<template>
  <v-dialog
    v-model="value"
    :width="width"
    persistent
  >
    <v-card>
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <slot>
          Are you sure?
        </slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          :color="color"
          text
          @click="$emit('input', true)"
        >
          {{ confirmText }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="$emit('input', false)"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirmation'
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    color: {
      type: String,
      default: 'danger'
    },
    width: {
      type: Number,
      default: 400
    }
  }
}
</script>
